// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "notifications";

export const notificationKeys = {
  // Base keys
  all: () => [collection],
 
};

export function invalidateJobQueries(notificationId) {
  const predicates = [
    // Invalidate all job lists
    ({ queryKey }) => queryKey[0] === collection,

  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}

export function invalidateAallNotificationQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) =>
      queryKey[0] === collection || queryKey[0] === "directus_notifications",
  });
}
